module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mod === 'default' && !_vm.backArrow) ? _c('div', {
    class: ['dof-search-bar', 'dof-search-bar-' + _vm.theme],
    style: _vm.barStyle
  }, [_c('input', {
    ref: "search-input",
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme],
    style: {
      width: _vm.inputWidth ? _vm.inputWidth + 'px' : _vm.showRightContent ? _vm.themeStyle.inputWidth : '686px'
    },
    attrs: {
      "returnKeyType": _vm.returnKeyType,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "value": _vm.value,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder
    },
    on: {
      "blur": _vm.onBlur,
      "focus": _vm.onFocus,
      "input": _vm.onInput,
      "return": _vm.onSubmit
    }
  }), (_vm.disabled) ? _c('div', {
    staticClass: ["disabled-input"],
    on: {
      "click": _vm.inputDisabledClicked
    }
  }) : _vm._e(), (_vm._theme != 'colmo') ? _c('image', {
    staticClass: ["search-bar-icon"],
    attrs: {
      "ariaHidden": true,
      "src": _vm.inputIcon
    }
  }) : (_vm._theme == 'colmo') ? _c('div', {
    staticClass: ["search-bar-icon"]
  }, [_c('dof-iconfont', {
    attrs: {
      "size": "64",
      "code": '\u4785',
      "color": "#71717A"
    }
  })], 1) : _vm._e(), (_vm.showClose && _vm._theme != 'colmo') ? _c('image', {
    staticClass: ["search-bar-close"],
    style: {
      right: _vm.showRightContent ? '144px' : '48px'
    },
    attrs: {
      "ariaHidden": true,
      "src": _vm.closeIcon
    },
    on: {
      "click": _vm.closeClicked
    }
  }) : (_vm.showClose && _vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: ["search-bar-close"],
    style: {
      right: _vm.showRightContent ? '144px' : '48px'
    },
    attrs: {
      "size": "48",
      "code": '\u4725',
      "color": "#71717A"
    },
    on: {
      "dofIconFontClicked": _vm.closeClicked
    }
  }) : _vm._e(), _vm._t("rightContent", [(_vm.showRightContent) ? _c('text', {
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: _vm.buttonStyle,
    on: {
      "click": _vm.rightClicked
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))]) : _vm._e()])], 2) : _vm._e(), (_vm.mod === 'default' && _vm.backArrow) ? _c('div', {
    class: ['dof-search-bar', 'dof-search-bar-' + _vm.theme],
    style: _vm.barStyle
  }, [(_vm._theme != 'colmo') ? _c('image', {
    staticClass: ["search-bar-arrow-base"],
    attrs: {
      "src": (_vm.theme == 'black' || _vm._isDiablo) ? _vm.W_backArrowIcon : _vm.B_backArrowIcon
    },
    on: {
      "click": _vm.backArrowClicked
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: ["search-bar-arrow"],
    attrs: {
      "size": "64",
      "code": '\u4717',
      "color": "rgba(255,255,255,0.80)"
    },
    on: {
      "dofIconFontClicked": _vm.backArrowClicked
    }
  }) : _vm._e(), _c('input', {
    ref: "search-input",
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme, 'search-bar-input-arrow-colmo'],
    style: {
      width: _vm.inputWidth ?
        _vm.inputWidth + 'px' :
        _vm.showRightContent && _vm.backArrow ?
        _vm.themeStyle.inputwithBackArrow :
        '610px',
      marginLeft: _vm.themeStyle.inputwithBackArrowLeft
    },
    attrs: {
      "returnKeyType": _vm.returnKeyType,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "value": _vm.value,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder
    },
    on: {
      "blur": _vm.onBlur,
      "focus": _vm.onFocus,
      "input": _vm.onInput,
      "return": _vm.onSubmit
    }
  }), (_vm.disabled) ? _c('div', {
    staticClass: ["disabled-input"],
    on: {
      "click": _vm.inputDisabledClicked
    }
  }) : _vm._e(), (_vm._theme != 'colmo') ? _c('image', {
    class: ['search-bar-icon', _vm.backArrow && 'search-bar-icon-hasArrow'],
    attrs: {
      "ariaHidden": true,
      "src": _vm.inputIcon
    }
  }) : _vm._e(), (_vm.showClose && _vm._theme != 'colmo') ? _c('image', {
    staticClass: ["search-bar-close"],
    style: {
      right: _vm.showRightContent && _vm.backArrow ? '136px' : '48px'
    },
    attrs: {
      "ariaHidden": true,
      "src": _vm.closeIcon
    },
    on: {
      "click": _vm.closeClicked
    }
  }) : (_vm.showClose && _vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: ["search-bar-close"],
    style: {
      right: _vm.showRightContent ? '136px' : '48px'
    },
    attrs: {
      "size": "48",
      "code": '\u4725',
      "color": "#71717A"
    },
    on: {
      "dofIconFontClicked": _vm.closeClicked
    }
  }) : _vm._e(), _vm._t("rightContent", [(_vm.showRightContent) ? _c('text', {
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: _vm.buttonStyle,
    on: {
      "click": _vm.rightClicked
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))]) : _vm._e()])], 2) : _vm._e(), (_vm.mod === 'hasSelect') ? _c('div', {
    class: ['dof-search-bar', 'dof-search-bar-' + _vm.theme],
    style: _vm.barStyle
  }, [_c('input', {
    class: ['search-bar-input', 'search-bar-input-' + _vm.theme],
    style: {
      width: _vm.inputWidth ? _vm.inputWidth + 'px' : _vm.showRightContent ? '590px' : '590px',
      paddingRight: '150px'
    },
    attrs: {
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "returnKeyType": _vm.returnKeyType,
      "value": _vm.value,
      "type": _vm.inputType,
      "placeholder": _vm.placeholder
    },
    on: {
      "blur": _vm.onBlur,
      "focus": _vm.onFocus,
      "input": _vm.onInput,
      "return": _vm.onSubmit
    }
  }), (_vm.disabled) ? _c('div', {
    staticClass: ["disabled-input", "has-dep-disabled"],
    on: {
      "click": _vm.inputDisabledClicked
    }
  }) : _vm._e(), _c('div', {
    class: ['bar-dep', '.bar-dep-' + _vm.theme]
  }, [_c('text', {
    ref: "selectedText",
    class: ['selected-text', 'selected-text-' + _vm.theme],
    on: {
      "click": _vm.showSelectList
    }
  }, [_vm._v(_vm._s(_vm.selectedText))]), (_vm.selectList) ? _c('div', {
    class: ['selectBlock', 'selectBlock-' + _vm.theme],
    style: _vm.selectBlockStyle
  }, _vm._l((_vm.list), function(item) {
    return _c('text', {
      key: item,
      class: ['select-text', 'select-text-' + _vm.theme],
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _c('image', {
    staticClass: ["dep-arrow"],
    attrs: {
      "src": _vm.arrowIcon,
      "ariaHidden": true
    },
    on: {
      "click": _vm.showSelectList
    }
  })]), _c('image', {
    staticClass: ["search-bar-icon"],
    attrs: {
      "ariaHidden": true,
      "src": _vm.inputIcon
    }
  }), _vm._t("rightContent", [(_vm.showRightContent) ? _c('text', {
    class: ['search-bar-button', 'search-bar-button-' + _vm.theme],
    style: _vm.buttonStyle,
    on: {
      "click": _vm.rightClicked
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))]) : _vm._e()])], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-1dc60808!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-searchbar/index.vue
// module id = 586
// module chunks = 0 1